<template>
    <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
      <v-card>
          <v-card-title class="text-h6">
              <span>{{ isEntryMode ? 'Add Section' : 'Update Section' }}</span>
          </v-card-title>
  
          <v-divider></v-divider>
  
          <v-card-text>
              <v-form @submit.prevent="submit" ref="SectionSetup">
                <v-row>
                    <v-col cols="12"> 

                        <v-text-field
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="name.value.value"
                            :error-messages="name.errorMessage.value"
                            clearable
                        >
                            <template #label>
                              Name
                              <span class="text-red-accent-4">*</span>
                            </template>
                        </v-text-field>

                        <v-select
                              label="Department"
                              density="compact"
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              v-model="department_id.value.value"
                              :error-messages="department_id.errorMessage.value"
                              :items="departmentList"
                              item-title="name"
                              item-value="id"
                              clearable
                          ></v-select>

                        <v-text-field
                              label="Remarks"
                              density="compact"
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              v-model="remarks.value.value"
                              :error-messages="remarks.errorMessage.value"
                              clearable
                          ></v-text-field>
                        
                        <v-checkbox                            
                            label="Active"
                            v-model="status.value.value"
                            :error-messages="status.errorMessage.value"
                            density="compact"
                            variant="outlined"
                            hide-details
                            single-line
                            color="primary"
                            value="1"
                        ></v-checkbox>
                        <input v-model="section_id.value.value" type="hidden">
                    </v-col>
                </v-row>
  
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout class="justify-end">
                        <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                          <v-btn 
                          class="bg-brand w-15 ms-2"  
                          variant="flat" 
                          type="submit"
                          >
                          {{ isEntryMode ? 'Save' : 'Update' }}
                          </v-btn>
                    </v-layout>
                </v-card-actions>
              </v-form>
          </v-card-text>
        
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { ref, watch } from 'vue'
  import { useStore } from 'vuex'
  import { useField, useForm } from 'vee-validate'
  import * as yup from 'yup'
  import { toast } from 'vue3-toastify'
  import { fileServerUrl } from "@/store/api";
  
  export default {
    name: 'SectionSetup',
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: () => ({
          name: '',
          department_id: null,
          remarks: '',
          status: '1',
          section_id: null,
        })
      }
    },
    data() {
      return {
        localDialog: this.dialog,
        errorMessages: '',
        loading: false,
        isEntryMode: true,
        departmentList: [],
      }
    },
    computed: {
     
    },
    watch: {
      dialog(val) {
        this.localDialog = val
      },
      localDialog(val) {
        this.$emit('update:dialog', val)
      },
      data: {
        handler(newData) {
          this.isEntryMode = !newData.id;
          this.resetForm({ errors: {}, touched: {} });
          this.name.setValue(newData.name || '', false);
          this.department_id.setValue(newData.department_id || null, false);
          this.remarks.setValue(newData.remarks || '', false);
          this.status.setValue(String(newData.status) || '1', false);
          this.section_id.setValue(newData.id || '', false);
        },
      }
      
    },
    created() {
      this.loadDepartmentList();
    },
    methods: {
      updateDialog(val) {
        this.$emit('update:dialog', val)
      },
      closeDialog() {
          this.$emit('update:dialog', false);
      },
      loadDepartmentList() {
        if(this.$store.getters.getHrmDepartmentList.length == 0){
          this.$store.dispatch('getHrmDepartmentList').then((response) => {
            this.departmentList = this.$store.getters.getHrmDepartmentList;
          });
        } else {
          this.departmentList = this.$store.getters.getHrmDepartmentList;
        }
      },
    },
    setup(props, { emit }){
      const { handleSubmit, resetForm} = useForm({
          validationSchema: yup.object({
            name: yup.string().min(1).max(50).required().trim().label('Name'),
            department_id: yup.number().required().label('Department'),
            remarks: yup.string().nullable().label('remarks')
          }),

      });
  
      const name = useField('name');
      const department_id = useField('department_id');
      const remarks = useField('remarks');
      const status = useField('status');
      const section_id = useField('section_id');
      const errorMessages = ref('');
      const loading  = ref('');
      const store = useStore();
  
      const submit = handleSubmit((values) => {
  
          store.dispatch("saveUpdateHrmSection", values)
              .then((response) => {
                  resetForm();
                  emit('update:dialog', false);
                  toast.success(response.data.message);
                  loading.value = true;
                  store.dispatch('getHrmSectionList')
                      .then(data => {
                          loading.value = false;
                      })
                      .catch(error => {
                          loading.value = false;
                          toast.error(error.response.data.message);
                      })
              })
              .catch((error) => {            
                  toast.error(error.response.data.message);          
              })
      });
      return {
        submit,
        remarks,
        name,
        department_id,
        status,
        errorMessages,
        section_id,
        resetForm,
        loading
      }
    },
    mounted() {
    }
  }
  </script>
  
  